enum SocketEvent {
  AppReload = 'APP_RELOAD',
  FullAccountUpdate = 'FULL_ACCOUNT_UPDATE',
  Logout = 'LOGOUT',
  EnablePasswordRecoveryField = 'ENABLE_PASSWORD_RECOVERY_FIELD',
}

export default SocketEvent
